import { ajaxJson } from 'imports/ajax';
import { map2EnrollmentObj } from 'imports/mapper';
import { createTypes } from 'redux-create-types';

const namespace = 'page-waiting';

export const waitingPageActions = createTypes([
    'toggleSpinner',
    'setError',
    'setEnrollmentDetails',
    'setEnrollmentStatus',
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: waitingPageActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: waitingPageActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function postEnrollmentApiSuccess(res, programId) {
    return dispatch => {
        const enrollmentObj = map2EnrollmentObj(res.data);
        dispatch({
            type: waitingPageActions.setEnrollmentDetails,
            payload: {
                invoiceId: enrollmentObj.invoiceId,
                enrollmentId: enrollmentObj.id,
            }
        })
        return dispatch(getUserStatusInProgramFromApi(programId, enrollmentObj));
    }
}

function postEnrollmentApiFail(err, programId) {
    return dispatch => {
        dispatch({
            type: waitingPageActions.setError,
            payload: err,
            meta: {
                apiName: 'enrollment'
            }
        });
        if (err.response.status === 404) {
            dispatch(postEnrollmentToApi(programId))
        }
        return dispatch(hideSpinner('enrollment'));
    }
}

function postEnrollmentToApi(programId) {
    return dispatch => {
        dispatch(showSpinner('enrollment'));
        return ajaxJson.post(`/programs/${programId}/enrollment`)
        .then(
            res => dispatch(postEnrollmentApiSuccess(res, programId)),
            err => dispatch(postEnrollmentApiFail(err)),
        ).then(() => {
            return dispatch(hideSpinner('enrollment'));
        })
    }
}

function getUserStatusInProgramApiSuccess(res, enrollmentObj) {
    return dispatch => {
        return dispatch({
            type: waitingPageActions.setEnrollmentStatus,
            payload: res.data['state'],
        })
    }
}

function getUserStatusInProgramApiFail(err) {
    return dispatch => {
        dispatch({
            type: waitingPageActions.setError,
            payload: err,
            meta: {
                apiName: 'enrollment'
            }
        })
        return dispatch(hideSpinner('enrollment-status'));
    }
}

function getUserStatusInProgramFromApi(programId, enrollmentObj) {
    return dispatch => {
        dispatch(showSpinner('enrollment-status'));
        return ajaxJson.get(`/programs/${programId}/enrollment/status`)
        .then(
            res => dispatch(getUserStatusInProgramApiSuccess(res, enrollmentObj)),
            err => dispatch(getUserStatusInProgramApiFail(err, programId)),
        ).then(() => {
            return dispatch(hideSpinner('enrollment-status'));            
        })
    }
}

export const overviewPageActionsCreators = {
    getUserStatusInProgramFromApi,
}